
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ContainerPaper from '../paper/ContainerPaper';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';


import { desktopMainContainer, desktopContentContainerPaperStyle } from '../../styles/shared/desktop';
import { mobileMainContainer } from '../../styles/shared/mobile';

import { sectionHeaderStyle, sectionTextStyle, subSectionHeaderStyle } from '../../styles/shared/variables';

import { desktopWelcomeTextContainerStyle, imageContainerStyle, imgBorderStyle } from './styles/desktop';
import { mobileWelcomeTextContainerStyle } from './styles/mobile';

const styles = theme => ({
    root: theme.mixins.gutters({
        marginTop: theme.spacing.unit * 3,
    })
});


class Summary extends React.Component {
    constructor(props) {
        super(props);
    }

    renderWelcomeTextContainer(showMobile) {
        return (
            <Grid item xs={showMobile ? 12 : 7} sm={showMobile ? 12 : 7}>
                <div style={sectionHeaderStyle}>
                    Welcome
            </div>
                <div style={sectionTextStyle}>
                    My name is Daniel Seskey, and I would like to welcome you to my website. This site contains several destinations for information about my past experiences. This page describes what information can be found in the menu options above.
            </div>
                <div style={subSectionHeaderStyle}>
                    Undergraduate Tab
            </div>
                <div style={sectionTextStyle}>
                    The undergraduate tab contains descriptions of courses taken throughout my undergraduate academic career at the University of Pittsburgh for Computer Engineering.
            </div>
                <div style={subSectionHeaderStyle}>
                    Graduate Tab
            </div>
                <div style={sectionTextStyle}>
                    The graduate tab contains descriptions of courses taken throughout my graduate academic career at the Pennsylvania State University.
            </div>
                <div style={subSectionHeaderStyle}>
                    Projects Tab
            </div>
                <div style={sectionTextStyle}>
                    The Project page contains basic information for past projects. Each project page contains a description, and samples from each project (completed and in progress).
            </div>
                <div style={subSectionHeaderStyle}>
                    About Me
            </div>
                <div style={sectionTextStyle}>
                    The About Me page contains a basic resume, my LinkedIn page, and other information.
            </div>
            </Grid>
        )
    }

    renderImage() {
        if (this.props.deviceType !== 'mobile') {
            return (
                <Grid item style={{ textAlign: 'center' }} xs={5} sm={5} >
                    <img src={require('../../resources/img/IMG_1961.jpeg')} alt='Pittsburgh - Fort Duquesne Bridge' width='300' style={imgBorderStyle} />

                </Grid>
                // <div style={imageContainerStyle}>
                // </div>
            )
        }

    }

    render() {
        const { classes, children, style, deviceType } = this.props;
        let showMobile = deviceType === 'mobile' ? true : false;
        return (
            <ContainerPaper id='summay-page-sub-container' style={desktopContentContainerPaperStyle}>
                <Grid container spacing={3}>
                    {this.renderImage()}
                    {this.renderWelcomeTextContainer(showMobile)}
                </Grid>
            </ContainerPaper>

        );
    }
}

Summary.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Summary);


// WEBPACK FOOTER //
// ./src/components/summary/Summary.js